import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1731716034156669';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        // Bootstrap the fbq queue
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        // Inject the loader script — append to head/body safely
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      // Fail silently — the page should never break because of analytics
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="stkne32z0i29">
      <main data-id="element-1" data-mp="35gnb7x88fm5">
        <Hero data-id="element-2" data-mp="34x1hg4gh72u" />
        <TestimonialsStrip data-id="element-3" data-mp="34ndfy2z19zs" />
        <PainPoints data-id="element-4" data-mp="3uct0lbuzo8ws" />
        <SolutionReveal data-id="element-5" data-mp="3udknlyaisybg" />
        <TomosSection data-id="element-6" data-mp="3ubzw6hji5vht" />
        <BonusSection data-id="element-7" data-mp="3uevsk1fpcc45" />
        <PricingSection data-id="element-8" data-mp="d4o0nv3yoa99" />
        <ExtendedTestimonials data-id="element-9" data-mp="d4xr1jsx4jfh" />
        <Guarantee data-id="element-10" data-mp="d45vg8zbmlp7" />
        <FAQ data-id="element-11" data-mp="d2bibguajxvo" />
        <FinalCTA data-id="element-12" data-mp="85l12q6r2w8o" />
      </main>
      <Footer data-id="element-13" data-mp="85b8cuubmaza" />
      <PurchaseNotifications data-id="element-14" data-mp="86w60tbxma1d" />
    </div>;
}